import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import * as React from 'react';
import { useTranslation } from 'react-i18next';


/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    message: React.ReactNode;
    title?: string;
    icon?: React.ReactNode;
    buttonYesText?: string;
    buttonNoText?: string;
    onClose: (result: boolean) => void;
}

type Props = IProps & Omit<DialogProps, "open" | "onClose">;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const MuiConfirmation: React.FC<Props> = (props) => {
    const { icon, title, message, buttonYesText, buttonNoText, onClose, ...rest } = props;
    const { t } = useTranslation();
    const noText = buttonNoText || t("Common.Buttons.NoText");
    const yesText = buttonYesText || t("Common.Buttons.YesText");

    return (
        <Dialog
            {...rest}
            open
            role="dialog"
            onClose={() => onClose(undefined)}
        >
            {title && <DialogTitle>{title}</DialogTitle>}

            <DialogContent>
                <Grid container alignItems="center">
                    {
                        icon &&
                        <Grid item>
                            {icon}
                        </Grid>
                    }
                    <Grid item xs>
                        <div style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                            <Typography variant="body1">
                                {message}
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <MuiRegularButton onClick={() => onClose(false)} color="default">
                    <span>{noText}</span>
                </MuiRegularButton>
                <MuiRegularButton onClick={() => onClose(true)} color="info" autoFocus>
                    <span>{yesText}</span>
                </MuiRegularButton>
            </DialogActions>
        </Dialog>

    );
};

MuiConfirmation.defaultProps = {
    fullWidth: true
};

export default MuiConfirmation;